import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControlLabel, Switch } from "@mui/material/";
import { strings } from "../../common/i18n";
import actions from "../../Store/actions";
import { logToSentry } from "../../config/Sentry";

/**
 * Hook for user table data and operations
 */
export default () => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    const { organisationSettings, settings } = useSelector(
        (state) => state.typesList
    );

    /** On editing columns */
    const onEdit = (row) => {
        try {
            setLoading(true);
            const { id, settingId, organisationId, value } = row;
            const val = value.toLowerCase() === "false" ? false : true;
            const data = {
                value: `${!val}`,
                settingId,
                organisationId
            };
            dispatch(
                actions.organisationSettings.create.patchRequest(
                    settingId,
                    data
                )
            );
            setRows((prevRows) =>
                prevRows.map((row) => {
                    return row.id === id ? { ...row, value: `${!val}` } : row;
                })
            );
        } catch (error) {
            logToSentry("Error updating options:", { error });
            dispatch(
                actions.toast.create.error(strings("errors.updatingOptions"))
            );
            console.log(error);
        }
        setLoading(false);
    };

    /** Rows data */
    const data = useMemo(() => {
        setLoading(true);
        const optionList = [];
        /** map settings with organisationSettings and get values*/
        settings.data &&
            organisationSettings.data &&
            settings.data.forEach((item) => {
                const optionType = organisationSettings.data.find(
                    (data) => data.settingId === item.id
                );
                if (optionType) {
                    optionList.push({
                        id:
                            optionType.id ||
                            `${item.id}-${optionType.organisationId}`, // Ensure unique ID
                        name: item.name,
                        description: item.description,
                        ...optionType
                    });
                }
            });

        setRows(optionList);
        setLoading(false);
        return optionList;
    }, [organisationSettings, settings]);

    /** Columns for Material React Table */
    const columns = useMemo(
        () => [
            {
                id: "name",
                header: strings("name"),
                accessorKey: "name",
                enableHiding: false,
                filterVariant: "autocomplete",
                size: 150
            },
            {
                id: "description",
                header: strings("description"),
                accessorKey: "description",
                filterVariant: "autocomplete",
                size: 150
            }
        ],
        [loading]
    );

    const rowActions = (row) => {
        const { value, name } = row.original;
        const val = value?.toLowerCase() === "false" ? false : true;
        return (
            <FormControlLabel
                key={`${name}-form`}
                control={
                    <Switch
                        key={`${name}-switch`}
                        checked={val}
                        onChange={() => onEdit(row.original)}
                        disabled={loading}
                    />
                }
            />
        );
    };

    return {
        columns,
        data,
        rows,
        rowActions,
        loading
    };
};
